// extracted by mini-css-extract-plugin
export default {"text":"PopupContent_text__2F41w","wrapper":"PopupContent_wrapper__70apS","title":"PopupContent_title__G8Okq"};